import * as ol from 'openlayers'
import BasePointAspect from './BasePointAspect'

export default class ParkingFacilityAspect extends BasePointAspect {

	// static states = {'Automatic':
	// {
	// 	style: new ol.style.Style({
	// 		image: new ol.style.Icon(({
	// 			anchorXUnits: 'fraction',
	// 			anchorYUnits: 'fraction',
	// 			src: this.getImagePath("ParkingFacility-states/", 'Automatic', '.svg'),
	// 			anchor: [0.5, 0.5],
	// 		}))
	// 	})
	// }, 'Close', 'Free', 'Full', 'Manual'};


	constructor(data) {
		super(data);
		this.set('type', 'ParkingFacility'); //should match dss object type

		this.set('operationalState', data.operationalState);
		this.set('stateText', data.stateText);
	}

	createStyle() {
		//returns a function that takes an image from the state folder
		let opState = this.get('operationalState');
		return function () {
			return [new ol.style.Style({
				image: new ol.style.Icon(/* @type {olx.style.IconOptions} */({
					anchorXUnits: 'fraction',
					anchorYUnits: 'fraction',
					src: this.getImagePath("ParkingFacility-states/", opState, '.svg'),
					anchor: [0.5, 0.5],
				}))
			})
			];
		};
	}
	createTooltip() {
		var id = "";
		var name = "";
		var totalCapacity = "";
		var freePlaces = "";
		var datumTime = "";

		var _id = this.getId();
		var _name = this.get('referenceName');
		var _parking_capacity = this.get('parking-capacity');
		var _vacant = this.get('vacant-spaces');
		var _last_upd = this.get('last-updated');
		var _timestamp = this.get('timestamp');

		var length = this.getLength(0, _id);
		if (typeof _id != 'undefined' && _id !== null) {
			id = "<p class='pop-up-atribute' >id: " + _id + "</p>";
		}
		if (typeof _name != 'undefined' && _name !== null && _name != "") {
			name = "<p class='pop-up-atribute' >name: " + _name + "</p>";
		}
		if (typeof _parking_capacity != 'undefined' && _parking_capacity != "") {
			totalCapacity = "<p class='pop-up-atribute' >parking-capacity: " + _parking_capacity + "</p>";
		} else {
			totalCapacity = "<p class='pop-up-atribute' >parking-capacity: -1</p>";
		}
		if (typeof _vacant != 'undefined' && _vacant != "") {
			freePlaces = "<p class='pop-up-atribute' >vacant-spaces: " + _vacant + "</p>";
		} else {
			freePlaces = "<p class='pop-up-atribute' >vacant-spaces: -1</p>";
		}
		if (typeof _last_upd != 'undefined' && _last_upd !== null && _last_upd != "") {
			datumTime = "<p class='pop-up-atribute'>last-updated: " + this.timeConverter(_last_upd) + "</p>";
		} else {
			if (typeof _timestamp != 'undefined' && _timestamp !== null && _timestamp != "") {
				datumTime = "<p class='pop-up-atribute'>timestamp: " + this.timeConverter(_timestamp) + "</p>";
			}
		}

		var tooltipInfo = "<div id='map-popup-tooltip' style='width:" + (length * 9) + "px;' >"
			+ id
			+ name
			+ totalCapacity
			+ freePlaces
			+ "<p class='pop-up-atribute' >state: " + this.get('state') + "</p>"
			+ datumTime;
		tooltipInfo += "</div>";
		return tooltipInfo;
	}

	static _objectDefinition() {
		return {
			name: '',
			capacity: '',
			ip: '',
			locationPosition: '',
		};
	}

	static createRequestObject(object) {
		let requestObject = {
			"PositionCode": {
				"datatype": "string",
				"value": object.locationPosition,
			},
			"ReferenceName": {
				"datatype": "string",
				"value": object.name,
			},
			"type": {
				"datatype": "string",
				"value": "ParkingFacility"
			},
			"ipaddress": {
				"datatype": "string",
				"value": object.ip,
			},
		}
		return requestObject;
	}
}
